import { useEffect, useState } from 'react'
import axios from 'axios';
import Loader from './Global/Loader';
import Swal from 'sweetalert2'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'


const MakePdf = () => {
    const [error, seterror] = useState([]);
    var datapdf = [];

    pdfMake.vfs = pdfFonts.pdfMake.vfs;

    const title = [
        // {
        //    margin: [ 5, 2, 10, 20 ],
        // //    snow: 'https://www.alsalamalgeria.com/themes/simpless/images/logo.png'
        // },
        // {
        //     // is supported loading images via url from reference by name in images
        //     Image: 'https://www.alsalamalgeria.com/themes/simpless/images/logo.png'
        //   },

        {
            // alignment: 'justify',
            // columnGap: 20,
            columns: [
                {
                    width: '20%',
                    margin: [5, 2, 10, 20],
                    // If no width/height/fit is used, then dimensions from the svg element is used.
                    svg: '<svg xmlns="http://www.w3.org/2000/svg" width="215" height="214" viewBox="0 0 215 214"> <g id="Groupe_137" data-name="Groupe 137" transform="translate(-1855 -343)"> <path id="Tracé_9347" data-name="Tracé 9347" d="M48,0H167a48,48,0,0,1,48,48V166a48,48,0,0,1-48,48H48A48,48,0,0,1,0,166V48A48,48,0,0,1,48,0Z" transform="translate(1855 343)" fill="#005042"/> <g id="Groupe_95" data-name="Groupe 95" transform="translate(2306.592 910.115)"> <g id="Pantone" transform="translate(-420.592 -552.115)"> <path id="Tracé_218" data-name="Tracé 218" d="M136.721,388.526s-.981,3.664-3.117,2c0,0-1.6-1.066-3.584,4.144,0,0-1.342,2.837-2.924,3.308,0,0,2.23.329,4.488-4.157a1.738,1.738,0,0,1,1.917-.906,1.926,1.926,0,0,0,2.664-.956s2.96,1.128,2.414-4.278c0,0-.391,2.482-1.825,2.009a7.175,7.175,0,0,0-.033-1.168m5.3-6.058c2.609.174,3.938-4.386,3.938-4.386,4.56-3.911,5.212-15.6,5.212-15.6.926-20.2-12.072-38.256-12.072-38.256l2.2,36.821a28.286,28.286,0,0,0,1.274-8.062c.059-3.228-1.14-17.115-1.14-17.115a52.211,52.211,0,0,1,7.728,20.151c1.031,8.562-2.6,13.806-2.6,13.806a17.384,17.384,0,0,0-.155-4.364c-.281-.879-.5-.2-.5-.2.264,8.01-3.046,10.2-3.046,10.2a18.772,18.772,0,0,0-.085-3.8c-.194-.958-.568-.522-.568-.522-.04,7.415-3.856,8.627-3.856,8.627a8.97,8.97,0,0,0,.66-4.346c-.169-.776-.468-.431-.468-.431-.52,5.626-4.217,6.332-4.217,6.332-7.342,1.212-6.915-13.782-6.915-13.782a128.852,128.852,0,0,0-5.255-38.836l-2.1,4.224c3.054,11.069,4.555,29.719,4.555,29.719l-.167,5.61c-.072,3.621-1.489,8.747-3.88,9.321a2.159,2.159,0,0,1-2.12-1.536c1.952-4.854,2.566-10.469,2.654-16.473,0-5.784-1.658-10.471-3.278-15.594-.406-1.277-.613-2.016-1.172-3.841-.271-.846-.654-2.1-.893-2.87-.45,4.721-1.055,7.793-1.717,12.341-.959,5.663-1.551,15.984-.575,22.449a22.162,22.162,0,0,1,.513,4.142,13.713,13.713,0,0,1-8.9,4.978c.761.784,7.1,1.06,10-.722a7.932,7.932,0,0,0,1.7,3.024,7.692,7.692,0,0,0,2.028,1.529c1.667.747,3.206.216,4.418-1.717a18.375,18.375,0,0,0,2.034-5c2.521,15.606,9.8,7.654,9.8,7.654,4.869,1.834,6.955-3.487,6.955-3.487m-25.441-9.3c-.272-.184-.416-.995-.6-1.361-2.1-6.833-1.182-15.716-.8-17.961a20.071,20.071,0,0,1,.69-3.146c.48,1.13.988,2.248,1.484,3.413,1.556,3.616,2.873,7.413,2.036,11.885A15.778,15.778,0,0,1,117,372.412c-.139.247-.276.5-.425.761m9.023,20.723a6.18,6.18,0,0,0-.707-4.224,7.72,7.72,0,0,1-.9-2.716c.314-.645.692-.279,1.008-.124.1-.114,0-.244.05-.341-.09-.552-.189-1.344-.68-1.5-.4-.1-.61.329-.737.722-.251,1.682.662,3.639,1.381,5a2.784,2.784,0,0,1-.013,2.138c-1.142-3.091-2.3-3.5-2.877-3.83-.535-.212-1.035-.371-1.107.328.03.66.232,1.917,1.05,2.158.309.082.411-.289.45-.567.592-.43,1.774,1.327,2.434,2.019-.58,1.426-1.947,2.608-2.111,3.019,0,0,2.208-.926,2.763-2.076m7.846-27.064c.1,1.013.854,1.459,1.536,1.257a3.153,3.153,0,0,0,1.421-1.317.961.961,0,0,0,.3.943c.64.3,1.772.744,2.3.023.963-1.827.58-3.617.236-5.74,0,0-.025-.376-.181-1.414a3.777,3.777,0,0,0-.632,2.325,33.033,33.033,0,0,1,.3,3.328,1.461,1.461,0,0,1-1.531-.618c-.072-1.543-.252-3.067-.252-4.7a3.505,3.505,0,0,0-.9,1.984l.08-.084a6.309,6.309,0,0,1,.272,2.751,1.378,1.378,0,0,1-1.825.632c-1.132-1.215.172-3.584.1-5.12a2.009,2.009,0,0,0-1,2l.184-.145c.013,1.173-.5,2.671-.411,3.893m3.1-18.329-1.413,2.442s1.834,3.6,1.177,9.608a20.533,20.533,0,0,0,.236-12.05m-7.875-.71c-.476,0-.593,1.63-.508,2.369.167.548.685.44,1.055.3.858,1.173,1.09,3.087,1.5,4.609.491-2.074.517-3.789,1.041-5.515.117-.47.421-.423.635-.176a1.445,1.445,0,0,1,.542,1.182c.3.211.973-1.72.523-2.708-.207-.471-.562-.851-1.1-.707-.535.182-1.031,2.068-1.234,3.216-.15.8-.226,1.65-.406,2.292-.052-.292-.085-.52-.174-.858-.388-1.458-.879-3.266-1.872-4m-20.007-7.641a31.253,31.253,0,0,1,1.132-4.4c.346-1.312.715-2.362,1.083-3.788l-.262.227a62.968,62.968,0,0,0-2.227,6.444c-.42,1.922-.958,4.354-.206,6.287.252.555.649,1.222,1.212,1.023,1.521-.829,1.536-3.585,1.8-5.665.077-.657-.11-.052-.144.155,0,.042-.075.51-.089.538-.259,1.227-.7,1.835-1.337,1.767-.4-.047-.732-.435-.9-1a.753.753,0,0,0-.038-.105c0-.028-.022-.069-.022-.105a3.237,3.237,0,0,1-.045-.936,2.6,2.6,0,0,1,.045-.435m18.989-11.768a30.23,30.23,0,0,1,1.132-4.4c.351-1.314.724-2.374,1.076-3.788l-.257.224a64.022,64.022,0,0,0-2.225,6.449c-.428,1.921-.954,4.354-.206,6.278.254.553.65,1.229,1.215,1.03,1.528-.834,1.528-3.592,1.8-5.667.08-.652-.115-.042-.149.154,0,.039-.072.513-.084.55-.266,1.225-.7,1.83-1.349,1.76-.4-.05-.73-.438-.9-1.01a.881.881,0,0,1-.028-.1c0-.03-.03-.069-.03-.109a3.15,3.15,0,0,1-.047-.934c.013-.144.022-.3.047-.435m-26.5,48.6C92.252,355.6,107.388,331,114.748,320.033c8.995-12.8,9.533-12.473,12.886-18.887,2.89-5.565,2.563-10.787,1.043-16.7a14.851,14.851,0,0,1-3.37,6.648c-2.882,3.413-3.845,3.853-6.091,5.138.194,1.471.854,2.14.774,6.285a6.245,6.245,0,0,1-.092,1c-1.9,2.962-8.966,10.81-14.823,22.225-5.1,9.953-7.047,16.239-8.2,22.326-2.133,11.3-1.265,18.839,2.524,30.3,12.177,31.13,26.855,33.719,31.731,47.566a10.235,10.235,0,0,0,.73,1.685,30.28,30.28,0,0,0-3.365-9.162c-9.169-15.7-16.4-15.238-27.339-41.467m28.29,34.342a.832.832,0,0,1,.931.383c.015.013.037.038.05.054a.358.358,0,0,0,.055.063,2.2,2.2,0,0,1,.261.652,1.558,1.558,0,0,1,.07.313,22.275,22.275,0,0,1,.221,3.438c.05,1.023.037,1.887.1,3l.142-.254a42.541,42.541,0,0,0,.114-5.225c-.144-1.481-.334-3.352-1.391-4.423-.308-.3-.774-.639-1.165-.3-.953,1.108-.282,3.009.017,4.553.105.475.089-.017.08-.165-.008-.025-.077-.371-.077-.4-.092-.939.089-1.511.593-1.68m29.894-53.255c-.13-16.427-9.028-35.173-9.028-35.173-4.423-9.523-19.019-38.446-19.019-38.446l2.145,60.623c2-4.527,1.877-10.683,1.877-10.683.13-6.6-1.57-33.54-1.57-33.54,25.7,42.53,22.436,63.61,22.436,63.61-1.937,22.208-14.27,31.155-14.27,31.155-20.34,14.008-36.119-12.634-36.119-12.634,15.928,33.41,34.431,20.519,34.431,20.519,20.761-13.986,19.118-45.43,19.118-45.43m-55.182,7.555c.552,3.759,1.655,7.3,1.658,11.253.042.042.038.084.1-.035.644-4.463-.879-8.426-1.292-12.66.649-.859,1.8-.623,2.681-.634a2.993,2.993,0,0,0,.284-1.444c-.608-.864-1.311-2.008-2.278-2-.344.013-.674.7-.859,1.224a4.27,4.27,0,0,0-.084,1.5c.194-.376.177-.879.572-1.077a.919.919,0,0,1,1.065.323,1.06,1.06,0,0,1-.657.129c-1.252.174-1.2,2.181-1.187,3.425M107,351.714a5.739,5.739,0,0,0-1.232,3.214,12.368,12.368,0,0,1-.416,2.29,6.512,6.512,0,0,0-.164-.861c-.391-1.461-.871-3.266-1.872-4.007-.463-.271-.687,2.064-.518,2.374a.844.844,0,0,0,1.056.3c.871,1.175,1.043,2.947,1.453,4.461l.162,0c.4-1.847.408-3.649.943-5.372.107-.473.333-.236.527-.1a1.469,1.469,0,0,1,.65,1.1c.321-.732.965-1.718.518-2.7-.261-.573-.841-.934-1.107-.707m16.1-39.081-1.367,1.588a14,14,0,0,1-.383,7.37,15.294,15.294,0,0,0,1.75-8.958m-5.394,19.521a21.2,21.2,0,0,1,4.726-7.092c5.367-4.963,4.4-9.332,4.4-9.332a15.881,15.881,0,0,1-5.128,7.149,13.882,13.882,0,0,0-4,9.275" transform="translate(-49.079 -263.452)" fill="#fff"/> <path id="Tracé_219" data-name="Tracé 219" d="M116.413,273.779c-1.023-.652-1.767-1.262-2.882-1.894l-1.712,2.573a27.728,27.728,0,0,0,2.957,1.929,22.8,22.8,0,0,0,1.636-2.608m31.917,8.809a1.987,1.987,0,0,0-1.377-.08,4.255,4.255,0,0,0-2.317,1.673,44.059,44.059,0,0,1-3.256,3.627,3.637,3.637,0,0,1-3.395.42,3.6,3.6,0,0,0,.463-.319c1.476-1.175,2.932-3.965,1.847-5.364a4.386,4.386,0,0,0-4.787-1.519,4.825,4.825,0,0,0-1.486.754,31.089,31.089,0,0,0-5.973,6.123,2.189,2.189,0,0,1-2.006-.635v-.015c-1.045-1.093-2.429-2.524-5.5-.689-2.3,1.4-3.987,3.674-7.2,8.214-1.687,2.38-6.332,2.352-5.02-3.4.008-.048.035-.246.06-.368,3.1-.207,6.309-.848,8.216-2.359a4.862,4.862,0,0,0,1.27-1.331,8.721,8.721,0,0,0,.929-1.844,6.5,6.5,0,0,0-1.135-6.233c-.288-.385-1.255-1.779-2.446-1.516-.682.028-1.673,1.391-2.049,2.121-.634,1.225-1.652,4.072,0,4.674a4,4,0,0,0,1.414.182c1.687-.085,1.922-.888,2.28-2.106a3.336,3.336,0,0,1,.532,1.483,3.68,3.68,0,0,1-.08,1.525c-.99.943-6.69,3.146-16.124,2.048-3.017-.518-1.431-5.657-.868-7.108l-.231-.105c-2.4,5.179-3.163,8.513,0,9.887.809.475,4.211.9,7.845.71a11.191,11.191,0,0,0-.374,2.151v1a5.946,5.946,0,0,0,.6,2.312,3.156,3.156,0,0,0,4.7,1.468c2.079-1.431,3.7-5.352,5.886-7.505,1.807-1.8,3.744-2.235,4.926-1.57s1.19,1.728,3.176,1.7c1.426.543,3.243.411,5.844-.4.453-.152.924-.274,1.332-.384,1.09-.284,1.936-.445,1.936-.445a2.249,2.249,0,0,0,2.507,1.692,4.167,4.167,0,0,0,3.559-2.163,17.79,17.79,0,0,1,1.545-1.807c0,.117.383.354.488.466a12,12,0,0,0,2.9,2.206c.657.308,1.275.4,1.668.037,1.621-1.5,1.774-6-.291-7.208m-32.425-1.21c-.6,1.15-1.775.894-1.835.057-.05-.8.354-1.128.7-1.2.664-.018,1.237.961,1.14,1.147m18.116,5.79a34.2,34.2,0,0,1-4.789.811s.66-.811,1.635-1.86a9.1,9.1,0,0,1,3.154-2.723,3.734,3.734,0,0,1,2.352-.152c1.081.385,2.3.889,2.449,2.009a20.446,20.446,0,0,1-4.8,1.916m14.207-.162v.08a3.043,3.043,0,0,1-1.275-.525,6.164,6.164,0,0,1-1.265-1.043c-.1,0-.067.017-.067-.07h.067c0-.132.485-.495.913-.523a1.39,1.39,0,0,1,.353.045c.918.194,1.28,1.023,1.344,2.036Zm-3.923,4.577a.675.675,0,0,0-.326-.05l-.008.012a.9.9,0,0,0-.358.219,2.8,2.8,0,0,1-.231.2c-.05.038-.129,0-.189.069a2.2,2.2,0,0,0-.114.214c-.067.157-.152.308-.222.466a2.524,2.524,0,0,1-.9.9,12.219,12.219,0,0,1-2.27,1.175c-.321.1-.629.227-.953.343a1.044,1.044,0,0,0-.411.179h-.017c0,.035.176.005.2.005.585-.022,1.147-.184,1.717-.256a2.882,2.882,0,0,0,1.173-.515,6.18,6.18,0,0,0,.841-.577,3.479,3.479,0,0,0,.465-.443,2.256,2.256,0,0,0,.4-.919h.04c0,.015.085.069.115.105a2.519,2.519,0,0,0,.705.53c.15.064.286.1.371.018a1.213,1.213,0,0,0-.025-1.675m-.043,1.021s0,0-.017.015a.533.533,0,0,1-.286-.132,2.642,2.642,0,0,1-.321-.239c-.015,0,0,.008,0-.017h0c0-.033.207-.1.236-.109h.085c.219.048.3.251.321.481Z" transform="translate(-47.563 -271.885)" fill="#fff"/> <path id="Tracé_220" data-name="Tracé 220" d="M84.526,364.383h-.943v9.546h4.776v-.817H84.526Zm29.43,0-3.908,9.546h.918l1.03-2.559h4.812l1.021,2.559h.981l-3.783-9.546Zm-1.6,6.17,2.074-5.27,2.069,5.27Zm-13.062-3.779c0-1.2,1.073-1.593,2.063-1.593a4.189,4.189,0,0,1,1.743.343l.152-.827a6.04,6.04,0,0,0-1.881-.3c-1.687,0-3.024.924-3.024,2.394,0,2.435,4.374,2.654,4.374,4.461,0,1.3-.971,1.884-2.141,1.884a3.867,3.867,0,0,1-2.108-.537l-.105.936a5.841,5.841,0,0,0,2.173.4c1.471,0,3.133-.752,3.133-2.611,0-2.678-4.38-2.7-4.38-4.545m-27.554-2.39-3.911,9.546h.916l1.026-2.559h4.817l1.026,2.559h.98l-3.781-9.546Zm-1.606,6.17,2.073-5.27,2.066,5.27Zm119.689-6.17-3.917,9.546h.918l1.02-2.559h4.826l1.01,2.559h1l-3.794-9.546Zm-1.616,6.17,2.078-5.27,2.071,5.27Zm18.357,2.232h-.028l-4.846-8.4h-1.2v9.546h.946V365.69h.017l4.771,8.239H207.5v-9.546h-.939Zm-28.221-3.841v-.033a1.977,1.977,0,0,0,1.737-2.18c0-1.829-1.459-2.347-3.01-2.347h-2.277v9.546h1.9c1.986,0,3.677-.649,3.677-2.725a2.224,2.224,0,0,0-2.028-2.262m-2.576-3.738h1.3c.8,0,2.078.187,2.078,1.576,0,1.506-1.331,1.775-2.323,1.775h-1.056Zm.956,7.907h-.985v-3.743h.832c1.394,0,2.857.177,2.857,1.879,0,1.523-1.431,1.864-2.7,1.864m38.807-4.234,4.624-4.495h-1.229l-4.291,4.274v-4.274h-.943v9.546h.943v-4.772l4.614,4.772h1.309Zm-75.806-4.495-3.911,9.546h.908l1.026-2.559h4.817l1.015,2.559h1l-3.783-9.546Zm-1.615,6.17,2.074-5.27,2.059,5.27Zm22.056,2.232-3.492-8.4H155.2v9.546h.951v-8.6h.027l3.582,8.6h.809l3.47-8.6h.032v8.6h.936v-9.546h-1.352Zm-34.535-8.4h-.941v9.546h4.771v-.817h-3.83Z" transform="translate(-67.825 -209.766)" fill="#fff"/> <g id="Groupe_94" data-name="Groupe 94" transform="translate(45.898 175.023)"> <g id="Groupe_93" data-name="Groupe 93" transform="translate(31.614)"> <path id="Tracé_221" data-name="Tracé 221" d="M119.422,378.511a1.34,1.34,0,0,0-.319.682,2.012,2.012,0,0,1,1.262-.657l.194-.5a1.353,1.353,0,0,1-.451.094,1.135,1.135,0,0,1-.786-.289.8.8,0,0,1,.652-.316.751.751,0,0,1,.252.043.731.731,0,0,0,.149-.373c0-.127-.1-.186-.288-.186a.9.9,0,0,0-.732.326,1.2,1.2,0,0,0-.338.7A.44.44,0,0,0,119.422,378.511Z" transform="translate(-110.958 -376.31)" fill="#fff"/> <path id="Tracé_222" data-name="Tracé 222" d="M122.744,379.322a2.244,2.244,0,0,1,.408,1.158h-6.1a3.025,3.025,0,0,0-.552-1.172l-.585.679a3.963,3.963,0,0,1,.406.607,3,3,0,0,1,.293.665,2.848,2.848,0,0,1-.732,1.081,1.429,1.429,0,0,1-.949.4,1.738,1.738,0,0,1-.741-.16c.033.057.067.087.07.114.1.117.16.2.2.234.366.478.694.724.963.724.3,0,.608-.219.946-.664a3.8,3.8,0,0,0,.685-1.484h6.268c.13-.316.222-.545.262-.679a3.121,3.121,0,0,0,.229-1.025,1.98,1.98,0,0,0-.5-1.265Z" transform="translate(-114.196 -375.283)" fill="#fff"/> <path id="Tracé_223" data-name="Tracé 223" d="M121.283,381.782a5.1,5.1,0,0,0,.169-1.369c0-.518-.033-1.175-.1-1.962l-.013-.125.192-.231-.2-1.3-.878,1.088c.052.359.1.9.14,1.628.05.883.075,1.58.075,2.1,0,.39-.025.868-.059,1.429A5,5,0,0,0,121.283,381.782Z" transform="translate(-109.993 -376.451)" fill="#fff"/> <path id="Tracé_224" data-name="Tracé 224" d="M122.9,378.513l-.669-.648-.546.509.685.617Z" transform="translate(-109.166 -375.736)" fill="#fff"/> <path id="Tracé_225" data-name="Tracé 225" d="M135.2,380.482a.755.755,0,0,0,.117-.378c0-.027-.005-.154-.012-.389l-.105-1.586.214.069.349-.8-.488-.206a1.486,1.486,0,0,1-.46-.261.543.543,0,0,1-.145-.338l-.371.608-.08.156a.527.527,0,0,0-.092.209c0,.117.1.209.308.259l.1,1.976c-.171.017-.3.028-.395.028a4.24,4.24,0,0,1-.48-.028h-.13a.6.6,0,0,0-.393.237l-.575.639a.922.922,0,0,1,.4-.1,1.532,1.532,0,0,1,.7.194c.207.11.4.216.568.314.311.186.53.308.647.366a1.435,1.435,0,0,0-.617.338H123.785a3.324,3.324,0,0,0-.555-1.172l-.585.679a5.079,5.079,0,0,1,.408.607,3.635,3.635,0,0,1,.289.665,2.864,2.864,0,0,1-.73,1.082,1.446,1.446,0,0,1-.951.4,1.732,1.732,0,0,1-.74-.16c.038.057.059.087.074.114a2.849,2.849,0,0,1,.184.234c.369.478.694.724.966.724.3,0,.615-.219.946-.664a3.815,3.815,0,0,0,.682-1.484h10.155a.8.8,0,0,0,.321-.05,2.176,2.176,0,0,0,.311-.266,2.166,2.166,0,0,1,1.484-.55,2.823,2.823,0,0,1,.821.112l.568-.913a4.247,4.247,0,0,1-1.3-.266A6.525,6.525,0,0,1,135.2,380.482Z" transform="translate(-109.68 -376.591)" fill="#fff"/> <path id="Tracé_226" data-name="Tracé 226" d="M128.752,381.235l.7.633.519-.483-.669-.64Z" transform="translate(-104.42 -373.801)" fill="#fff"/> <path id="Tracé_227" data-name="Tracé 227" d="M132.055,378.325l.187-.231-.209-1.3-.869,1.088c.048.359.1.9.144,1.628.043.883.072,1.58.072,2.1,0,.39-.017.868-.067,1.429a5.428,5.428,0,0,0,.682-1.262,5.11,5.11,0,0,0,.165-1.369c0-.518-.035-1.175-.1-1.962Z" transform="translate(-102.801 -376.451)" fill="#fff"/> </g> <path id="Tracé_228" data-name="Tracé 228" d="M98.556,377.636l-.958,2.417h1.889Zm-1.2,3.128-.5,1.347c-.2.54-.266.811.194.985v.03H95.283v-.03a2.117,2.117,0,0,0,.929-1.356l1.6-3.99c.134-.354.314-.751-.139-.894v-.028h1.506l1.989,4.913a2.232,2.232,0,0,0,.943,1.356v.03h-1.964v-.03c.471-.211.391-.311.134-.985l-.518-1.347Z" transform="translate(-95.283 -376.433)" fill="#fff"/> <path id="Tracé_229" data-name="Tracé 229" d="M100.147,376.888c.219,0,.468.01.607-.15h.033v5.389c0,.438-.07.791.353,1.03v.033H99.56v-.033c.415-.239.351-.592.351-1.03v-4.176c0-.441.064-.792-.351-1.035v-.028Z" transform="translate(-92.411 -376.493)" fill="#fff"/> <path id="Tracé_230" data-name="Tracé 230" d="M103.451,380.512a.923.923,0,0,0,.988-.934,1.1,1.1,0,0,0-1.187-1.058c-.535,0-.98.283-.98.839a1.193,1.193,0,0,0,1.178,1.153m2.792-2.623-.214.493c-.08.171-.1.232-.306.232a7.406,7.406,0,0,1-.985-.124,1.365,1.365,0,0,1,.674,1.157c0,1.081-1.167,1.411-2.033,1.493-.139.007-.4.092-.4.257,0,.209.451.175.573.175,1.662,0,2.541.455,2.541,1.4,0,1.088-1.2,1.688-2.69,1.688-1.412,0-2.653-.543-2.653-1.359,0-.537.425-.776.916-.776a1.186,1.186,0,0,1,.547.124.4.4,0,0,0-.366.433c0,.8.959.948,1.583.948s1.692-.181,1.692-.988c0-.839-1.364-.889-1.954-.889l-.66.017a.68.68,0,0,1-.7-.677c0-.279.552-.411.752-.508a1.562,1.562,0,0,1-1.257-1.473c0-1.11,1.073-1.625,2.056-1.625Z" transform="translate(-91.608 -375.719)" fill="#fff"/> <path id="Tracé_231" data-name="Tracé 231" d="M107.76,379.5a1.1,1.1,0,0,0-1.232-.981,1.186,1.186,0,0,0-1.237.981Zm-2.511.555a1.8,1.8,0,0,0,1.922,1.854,2.544,2.544,0,0,0,1.568-.512h.027l-.475.9a3.546,3.546,0,0,1-1.319.241,2.5,2.5,0,0,1-2.758-2.364,2.248,2.248,0,0,1,2.4-2.29,2.051,2.051,0,0,1,2.153,2.166Z" transform="translate(-89.285 -375.719)" fill="#fff"/> <path id="Tracé_232" data-name="Tracé 232" d="M107.883,378.011a.963.963,0,0,0,.583-.122h.038v.725a1.257,1.257,0,0,1,1.123-.725l.344.025v.876a.611.611,0,0,0-.435-.147c-.734,0-1.033.379-1.033,1.366v1.344c0,.438-.07.791.354,1.03v.03h-1.595v-.03c.421-.239.361-.592.361-1.03v-2.287c0-.445.06-.791-.358-1.026v-.028Z" transform="translate(-87.236 -375.719)" fill="#fff"/> <path id="Tracé_233" data-name="Tracé 233" d="M109.839,378.1a.619.619,0,0,1-.62-.635.6.6,0,1,1,.62.635m-.186.573a.913.913,0,0,0,.622-.161h.033v3.5c0,.438-.059.791.358,1.03v.03h-1.59v-.03c.416-.239.358-.592.358-1.03v-2.287c0-.445.058-.791-.358-1.026v-.028Z" transform="translate(-86.019 -376.383)" fill="#fff"/> <path id="Tracé_234" data-name="Tracé 234" d="M114.472,382.543c-.63-.042-1.27-.231-1.27-1v-1.514a3.828,3.828,0,0,1-.916.3c-.456.105-.973.2-.973.791s.535.789,1.043.789a2.421,2.421,0,0,0,.69-.142l-.563.722a2.752,2.752,0,0,1-.5.054,1.493,1.493,0,0,1-1.641-1.416c0-1.777,2.857-.951,2.857-2,0-.461-.558-.608-.916-.608a2.954,2.954,0,0,0-1.3.376l.64-.956.625-.053c1.031,0,1.819.293,1.827,1.451v1.438c0,.752.022,1.041.819,1.132Z" transform="translate(-85.168 -375.719)" fill="#fff"/> </g> </g> </g> </g> </svg>',
                    width: 60,
                },
                {
					text: 'Lorem ipsum ',
                    width: '*',
                    alignment: 'right' 
				},
            ]
        },
        
    ]


//------------------
    // // Provided data
    // const principal = 16018.90;           // Initial amount borrowed or invested
    // const annual_interest_rate = 10.6;    // Annual interest rate in percentage
    // const duration_in_months = 60;        // Duration of the loan in months

    // // Calculate monthly interest rate
    // const monthly_interest_rate = (annual_interest_rate / 100) / 12;

    // // Calculate monthly payment using the formula for an annuity
    // // P = (r*PV) / (1 - (1 + r)^-n)
    // const monthly_payment = (monthly_interest_rate * principal) / (1 - Math.pow((1 + monthly_interest_rate), -duration_in_months));

    // console.log("Monthly Payment: " + monthly_payment.toFixed(2) + "\n");

    // // Simulation of each month's payment
    // let remainingPrincipal = principal;
    // for (let month = 1; month <= duration_in_months; month++) {
    //     const interest_for_month = remainingPrincipal * monthly_interest_rate;
    //     const principal_for_month = monthly_payment - interest_for_month;
    //     remainingPrincipal -= principal_for_month;

    //     datapdf = [...datapdf,{
    //         "Month": month,
    //         "InterestPayment": interest_for_month.toFixed(2),
    //         "PrincipalPayment": principal_for_month.toFixed(2),
    //         "OutstandingAmount": remainingPrincipal.toFixed(2) ,
    //         "PrincipalPayment": principal_for_month.toFixed(2),
    //         "OutstandingAmount": remainingPrincipal.toFixed(2) ,
     


    //     } ]

    //     // console.log("Month " + month + ":");
    //     // console.log("Interest Payment: " + interest_for_month.toFixed(2));
    //     // console.log("Principal Payment: " + principal_for_month.toFixed(2));
    //     // console.log("Outstanding Amount: " + remainingPrincipal.toFixed(2) + "\n");
    // }
//------------------

    // var datapdf = [{
    //     "11": 1,
    //     "12": "141.50",
    //     "13": "203.60",
    //     "14": "15815.30",
    //     "15": "15815.30"
    // },
    // {
    //     "11": 1,
    //     "12": "141.50",
    //     "13": "203.60",
    //     "14": "15815.30",
    //     "15": "15815.30"

    // }]


    function PaymentDate(date_input, addMonth) {

        if (addMonth == 1) {

            var dateInA14 = new Date("7/15/2028"); // Replace '15/9/2023' with the actual value in cell A14


            var newDate = new Date(dateInA14.setMonth(dateInA14.getMonth() - 58));



            // console.log(result);
            //   console.log(newDate.toLocaleDateString("en-US"));
            return newDate.toLocaleDateString("en-US");


        }

        var dateInA14 = new Date(date_input); // Replace '15/9/2023' with the actual value in cell A14


        var newDate = new Date(dateInA14.setMonth(dateInA14.getMonth() + 1));



        // console.log(result);
        return newDate.toLocaleDateString("en-US");
    }
    
    const initValueOutstandingLast = [];
    var lastmonth ="";

    for (let index = 0; index < 58; index++) {


        if (index == 0) {

             lastmonth = PaymentDate("7/16/2023", 1);
             initValueOutstandingLast[index] = -606200.01;
            var initValueOutstanding = -606200.01;
            var initValueProfit = (Math.abs(initValueOutstanding) * 60 * 10.6 / 36000).toFixed(2);
            var initValueCharge = ((initValueProfit * 19) / 100).toFixed(2);
            var initValueTotalPayment = 13984.09;
            var initValuePrincipal = initValueTotalPayment - Math.abs(initValueCharge) - Math.abs(initValueProfit);
            var initValueOutstandingafter = initValueOutstanding + initValuePrincipal;
             initValueOutstandingLast[index] = initValueOutstandingafter

            console.log("month " + lastmonth + " initValueProfit " + initValueProfit + " initValuePrincipal " + initValuePrincipal + " initValueCharge " + initValueCharge + " initValueTotalPayment " + initValueTotalPayment + " initValueOutstanding " + initValueOutstandingafter)

            datapdf = [...datapdf,{
                "Month": lastmonth,
                "InterestPayment": initValueTotalPayment.toFixed(2),
                "PrincipalPayment": initValuePrincipal.toFixed(2),
                "Profit": initValueProfit,
                "Charge": initValueCharge,
                "OutstandingAmount": initValueOutstandingafter.toFixed(2),
         
    
    
            } ]


        } else {


          lastmonth = PaymentDate(lastmonth, 2);


            initValueOutstanding = initValueOutstandingLast[index - 1];
            // console.log(initValueOutstanding)


            var initValueProfit = (Math.abs(initValueOutstanding) * 30 * 10.6 / 36000).toFixed(2);
            var initValueCharge = ((initValueProfit * 19) / 100).toFixed(2);
            var initValueTotalPayment = 13984.09;
            var initValuePrincipal = initValueTotalPayment - Math.abs(initValueCharge) - Math.abs(initValueProfit);
            // console.log(initValuePrincipal)

            initValueOutstandingafter = initValueOutstanding + initValuePrincipal;
            initValueOutstandingLast[index] = initValueOutstandingafter

            console.log("month " + lastmonth + " initValueProfit " + initValueProfit + " initValuePrincipal " + initValuePrincipal + " initValueCharge " + initValueCharge + " initValueTotalPayment " + initValueTotalPayment + " initValueOutstanding " + initValueOutstandingafter)

            datapdf = [...datapdf,{
                "Month": lastmonth,
                "InterestPayment": initValueTotalPayment.toFixed(2),
                "PrincipalPayment": initValuePrincipal.toFixed(2),
                "Profit": initValueProfit,
                "Charge": initValueCharge,
                "OutstandingAmount": initValueOutstandingafter.toFixed(2),
         
    
    
            } ]
        }
    }



    console.log(datapdf);

    const getMapData = datapdf.map((inside, index) => {
        return [
            {
                text: new Date(inside.Month).toLocaleDateString('en-gb', { day: 'numeric' , year: 'numeric', month: 'long',  }) ,fontSize : 8
            },
            {
                text: inside.InterestPayment + ' DA' ,fontSize : 8
            },  {
                text: inside.PrincipalPayment + ' DA' ,fontSize : 8
            },
            {
                text: inside.Profit + ' DA' ,fontSize : 8
            },{
                text: inside.Charge + ' DA' ,fontSize : 8
            }, {
                text: inside.OutstandingAmount + ' DA' ,fontSize : 8
            },        
        ];
    })

    const docDefinition = {
        pageSize: "A4",
        // header : [title],
        pageMargins: [10, 10, 10, 10],
        content: [
            title,
            
            {
                style: 'tableExample',
                table: {
                    headerRows: 1,
                    widths: ['*', '*', '*', "*", '*', "*"],
                    body: [

                        [{text: 'Date', style: 'tableHeader',fontSize : 8 ,bold: true,	fillColor: '#eeeeee',}, {text: 'Total Amount', style: 'tableHeader',fontSize : 8 ,bold: true,	fillColor: '#eeeeee',}, {text: 'Principal', style: 'tableHeader',fontSize : 8 ,bold: true,	fillColor: '#eeeeee',}, {text: 'Profit', style: 'tableHeader',fontSize : 8 ,bold: true,	fillColor: '#eeeeee',}, {text: 'Charges', style: 'tableHeader',fontSize : 8 ,bold: true,	fillColor: '#eeeeee',}, {text: 'Outstanding', style: 'tableHeader',fontSize : 8 ,bold: true,	fillColor: '#eeeeee',}],

                        // [
                        //     {
                        //         text: "hhh"
                        //     },
                        //     {
                        //         text: "hhh"
                        //     },  {
                        //         text: "hhh"
                        //     },
                        //     {
                        //         text: "hhh"
                        //     },
                            
                        // ],
                        // [
                        //     {
                        //         text: "hhh"
                        //     },
                        //     {
                        //         text: "hhh"
                        //     },  {
                        //         text: "hhh"
                        //     },
                        //     {
                        //         text: "hhh"
                        //     },
                            
                        // ],
                        ...getMapData

                        // ['item1', 'item2','item1', 'item2','item1'],

                        // ['item1', 'item2','item1', 'item2','item1'],

                        // ['item1', 'item2','item1', 'item2','item1'],


                        // ['Mois', 'Interest Payment', 'Principal Payment','Outstanding Amount'],

                        // [{
                        //     text: "hhh"
                        // },
                        // {
                        //     text: "hhh"
                        // }],
                        // [{
                        //     text: "hhh"
                        // },
                        // {
                        //     text: "hhh"
                        // }]
                        // ,
                        // [{
                        //     text: "hhh"
                        // },
                        // {
                        //     text: "hhh"
                        // }]

                        

                        //         datapdf?.map((item, i) => {
                        //             [


                        //                 item.map((iteminside => (

                        //                 {
                        //                     text: [
                        //                         'Inlines can be ',
                        //                         { text: 'styled\n', italics: true },
                        //                         { text: 'easily as everywhere else', fontSize: 10 }]
                        //                 },
                        //                 ))
                        //             ]


                        // })

                        // [
                        //     {
                        //         text: [
                        //             'Inlines can be ',
                        //             { text: 'styled\n', italics: true },
                        //             { text: 'easily as everywhere else', fontSize: 10 }]
                        //     },
                        //     {
                        //         text: [
                        //             'Inlines can be ',
                        //             { text: 'styled\n', italics: true },
                        //             { text: 'easily as everywhere else', fontSize: 10 }]
                        //     },
                        //     {
                        //         text: [
                        //             'Inlines can be ',
                        //             { text: 'styled\n', italics: true },
                        //             { text: 'easily as everywhere else', fontSize: 10 }]
                        //     },
                        //     {
                        //         text: [
                        //             'Inlines can be ',
                        //             { text: 'styled\n', italics: true },
                        //             { text: 'easily as everywhere else', fontSize: 10 }]
                        //     },
                        //     {
                        //         text: [
                        //             'Inlines can be ',
                        //             { text: 'styled\n', italics: true },
                        //             { text: 'easily as everywhere else', fontSize: 10 }]
                        //     }
                        // ],

                    ]
                },
                layout: 'lightHorizontalLines'
            },


        ],
        footer: [[]]

    }

    //  var docDefinition = {
    //     // a string or { width: number, height: number }
    //     pageSize: 'A5',

    //     // by default we use portrait, you can change it to landscape if you wish
    //     pageOrientation: 'landscape',
    //     header : [title],

    //     // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
    //     pageMargins: [ 40, 60, 40, 60 ],
    //   };

    pdfMake.createPdf(docDefinition).download()


    console.log(error);




    const [NometPrenom, setNometPrenom] = useState('');
    const [secteuActivité, setsecteuActivité] = useState('');
    const [Tel, setTel] = useState('')

    const [Lang, setLang] = useState("ar")


    const [Wilaya, setWilaya] = useState('')

    const [Commune, setCommune] = useState('')
    const [Communesdenaissence, setCommunesdenaissence] = useState([])

    useEffect(() => {

        const GetCommune = async () => {
            try {
                const { data: response } = await axios.get(`https://opr.diardzair.com.dz/ws/region/wilayatocommune?valeur=${Wilaya}`);


                setCommunesdenaissence(response['communes'])
                setCommune('')

            } catch (error) {
                // console.error(error.message);
            }
        }

        if (Wilaya !== '') {
            GetCommune();
        }


    }, [Wilaya])





    function GoNext() {

        setShowerrors(true)

        if (errors.NometPrenom[Lang] !== '' || errors.secteuActivité[Lang] !== '' || errors.Tel[Lang] !== '') {
            const matches = document.querySelectorAll(".err-cart-sum");
            for (let index = 0; index < matches.length; index++) {
                if (matches[index].textContent.trim() !== '') {

                    let position = matches[index].getBoundingClientRect();
                    window.scrollTo(position.left, position.top + window.scrollY - 120);
                    return
                }
            }
            return;
        }

        const SentForm = async () => {
            setLoading(true)
            try {
                const { data: response } = await axios.post(`${process.env.REACT_APP_LOCAL_URL}/reclamations/form-register`, { "nom": NometPrenom, "wilaya": Wilaya, "commune": Commune, "tel": Tel, "secteur_activite": secteuActivité }, {
                    // headers: {
                    //   'Content-Type': 'application/x-www-form-urlencoded'
                    // }
                });

                // console.log(response['errorCode']);
                console.log(response);
                if (response['error'] == false) {
                    // console.log(response.data['err']);
                    Swal.fire({
                        title: Lang === "fr" ? 'Succès' : 'تم الإرسال',
                        type: 'success',
                        text: Lang === "fr" ? 'Votre demande a été envoyée avec succès. Nous vous contacterons bientôt' : 'تم إرسال طلبك بنجاح, سيتم التواصل معك قريبا',
                        // timer: 4000,
                        showConfirmButton: true,
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        icon: 'success',

                    }).then(function (isConfirm) {
                        if (isConfirm) {
                            window.location = "https://new.diardzair.com.dz/assistence";
                        }
                    })


                    // .then(function() {
                    //     window.location = "/";
                    // });


                } else {

                    if (response['errorList'].constructor == Array) {
                        seterror(response['errorList'])
                    }



                    Swal.fire({
                        title: 'Problème',
                        type: 'error',
                        text: Lang === "fr" ? "Il y a un problème lors de l'ajout de données." : "هناك مشكل في إرسال طلبك يرجى المحاولة مرة أخرى",
                        timer: 2000,
                        showConfirmButton: false,
                        icon: 'error',
                        didClose: () => window.scrollTo(0, 0)



                    });
                }

                setLoading(false)
                // localStorage.removeItem('cart')



            } catch (error) {
                setLoading(false)
                // console.error(error.message);
            }
        }

        SentForm();



    }

    function hasNumber(myString) {
        return /\d/.test(myString);
    }

    function onlyNumbers(str) {
        return /^[0-9]+$/.test(str);
    }

    function isValidEmail(string) {
        // The regular expression used by [type="email"]
        var regex = /^([A-Za-z0-9\.])+\@([A-Za-z0-9])+\.([A-Za-z]{2,4})$/;
        // Test the string against the regular expression
        return regex.test(string)
    }


    const [Loading, setLoading] = useState(false)


    const [errors, seterrors] = useState({ Titreduproduit: { "fr": '', "ar": "" }, Réferenceduproduit: { "fr": '', "ar": "" }, Marque: { "fr": '', "ar": "" } })
    const [err, seterr] = useState([])

    const [Showerrors, setShowerrors] = useState(false)

    function Validate() {

        if (NometPrenom?.toString().trim().length > 300 || NometPrenom?.toString().trim() == '') {
            seterrors((prev) => ({ ...prev, NometPrenom: { "fr": 'Veuillez écrire votre nom et prénom', "ar": "يرجى كتابة الإسم واللقب" } }))
        } else {
            seterrors((prev) => ({ ...prev, NometPrenom: { "fr": '', "ar": "" } }))
        }

        if (Tel?.toString().trim().length > 12 || Tel?.toString().trim().length < 9 || Tel?.toString().trim() == '' || !onlyNumbers(Tel)) {
            seterrors((prev) => ({ ...prev, Tel: { "fr": "Veuillez écrire un numéro de téléphone valide (Max 12) (Min 9)", "ar": "(Max 12) (Min 9) - يرجى كتابة رقم هاتف صحيح" } }))
        } else {
            seterrors((prev) => ({ ...prev, Tel: { "fr": '', "ar": "" } }))
        }

        if (secteuActivité?.toString().trim().length > 300 || secteuActivité?.toString().trim() == '') {
            seterrors((prev) => ({ ...prev, secteuActivité: { "fr": "Veuillez écrire le domaine d'activité", "ar": "برجى تحديد قطاع النشاط" } }))
        } else {
            seterrors((prev) => ({ ...prev, secteuActivité: { "fr": '', "ar": "" } }))
        }

        if (Wilaya?.toString().trim() == '' || Wilaya?.toString().trim().length > 300) {
            seterrors((prev) => ({ ...prev, Wilaya: { "fr": 'Veuillez sélectionner La Wilaya ', "ar": "يرجى تحديد الولاية" } }))
        } else {
            seterrors((prev) => ({ ...prev, Wilaya: { "fr": '', "ar": "" } }))
        }

        if (Commune?.toString().trim() == '' || Commune?.toString().trim().length > 300) {
            seterrors((prev) => ({ ...prev, Commune: { "fr": 'Veuillez sélectionner La Commune', "ar": "يرجى تحديد البلدية" } }))
        } else {
            seterrors((prev) => ({ ...prev, Commune: { "fr": '', "ar": "" } }))
        }


    }

    useEffect(() => {

        Validate();

    }, [NometPrenom, Tel, secteuActivité, Wilaya, Commune])

    useEffect(() => {

        if (Showerrors) {
            const matches = document.querySelectorAll(".err-cart-sum");
            for (let index = 0; index < matches.length; index++) {
                if (matches[index].textContent.trim() !== '') {
                    let position = matches[index].getBoundingClientRect();
                    window.scrollTo(position.left, position.top + window.scrollY - 120);
                    return
                }
            }
        }
    }, [Showerrors])



    const WilayaList = [{ "value": "ADRAR", 'text': "(01) ADRAR" },
    { "value": "CHLEF", 'text': "(02) CHLEF" },
    { "value": "LAGHOUAT", 'text': "(03) LAGHOUAT" },
    { "value": "OUM EL BOUAGHI", 'text': "(04) OUM-EL-BOUAGHI" },
    { "value": "BATNA", 'text': "(05) BATNA" },
    { "value": "BEJAIA", 'text': "(06) BEJAIA" },
    { "value": "BISKRA", 'text': "(07) BISKRA" },
    { "value": "BECHAR", 'text': "(08) BECHAR" },
    { "value": "BLIDA", 'text': "(09) BLIDA" },
    { "value": "BOUIRA", 'text': "(10) BOUIRA" },
    { "value": "TAMANRASSET", 'text': "(11) TAMANRASSET" },
    { "value": "TEBESSA", 'text': "(12) TEBESSA" },
    { "value": "TLEMCEN", 'text': "(13) TLEMCEN" },
    { "value": "TIARET", 'text': "(14) TIARET" },
    { "value": "TIZI OUZOU", 'text': "(15) TIZI-OUZOU" },
    { "value": "ALGER", 'text': "(16) ALGER" },
    { "value": "DJELFA", 'text': "(17) DJELFA" },
    { "value": "JIJEL", 'text': "(18) JIJEL" },
    { "value": "SETIF", 'text': "(19) SETIF" },
    { "value": "SAIDA", 'text': "(20) SAIDA" },
    { "value": "SKIKDA", 'text': "(21) SKIKDA" },
    { "value": "SIDI BEL ABBES", 'text': "(22) SIDI-BEL-ABBES" },
    { "value": "ANNABA", 'text': "(23) ANNABA" },
    { "value": "GUELMA", 'text': "(24) GUELMA" },
    { "value": "CONSTANTINE", 'text': "(25) CONSTANTINE" },
    { "value": "MEDEA", 'text': "(26) MEDEA" },
    { "value": "MOSTAGANEM", 'text': "(27) MOSTAGANEM" },
    { "value": "M SILA", 'text': "(28) M-SILA" },
    { "value": "MASCARA", 'text': "(29) MASCARA" },
    { "value": "OUARGLA", 'text': "(30) OUARGLA" },
    { "value": "ORAN", 'text': "(31) ORAN" },
    { "value": "EL BAYADH", 'text': "(32) EL-BAYADH" },
    { "value": "ILLIZI", 'text': "(33) ILLIZI" },
    { "value": "BORDJ BOU ARRERIDJ", 'text': "(34) BORDJ-BOU-ARRERIDJ" },
    { "value": "BOUMERDES", 'text': "(35) BOUMERDES" },
    { "value": "EL TARF", 'text': "(36) EL-TARF" },
    { "value": "TINDOUF", 'text': "(37) TINDOUF" },
    { "value": "TISSEMSILT", 'text': "(38) TISSEMSILT" },
    { "value": "EL OUED", 'text': "(39) EL-OUED" },
    { "value": "KHENCHELA", 'text': "(40) KHENCHELA" },
    { "value": "SOUK AHRAS", 'text': "(41) SOUK-AHRAS" },
    { "value": "TIPAZA", 'text': "(42) TIPAZA" },
    { "value": "MILA", 'text': "(43) MILA" },
    { "value": "AIN DEFLA", 'text': "(44) AIN-DEFLA" },
    { "value": "NAAMA", 'text': "(45) NAAMA" },
    { "value": "AIN TEMOUCHENT", 'text': "(46) AIN-TEMOUCHENT" },
    { "value": "GHARDAIA", 'text': "(47) GHARDAIA" },
    { "value": "RELIZANE", 'text': "(48) RELIZANE" },];


    const Label = {
        "name": { 'ar': "الإسم واللقب", 'fr': "Nom et Prénom" }, "Mobile": { 'ar': "رقم الهاتف", 'fr': "Numéro téléphone" }, "wilaya": { "ar": "الولاية", "fr": "Wilaya" }
        , "commune": { "ar": "البلدية", "fr": "Commune" }, "secteur": { "ar": "قطاع النشاط", "fr": "Secteur d'activité" }
    }

    const changeLang = (lng) => {
        setLang(lng);
    }

    const secteuActivitéList = [
        { "ar": { "value": "أجهزة كهرومنزلية", 'text': "أجهزة كهرومنزلية" }, "fr": { "value": "Électroménager", 'text': "Électroménager" } },
        { "ar": { "value": "أثاث", 'text': "أثاث" }, "fr": { "value": "Meubles", 'text': "Meubles" } },
        { "ar": { "value": "أجهزة كهرومنزلية وأثاث", 'text': "أجهزة كهرومنزلية وأثاث" }, "fr": { "value": "Électroménager et Meubles", 'text': "Électroménager et Meubles" } },
        { "ar": { "value": "أخرى", 'text': "أخرى" }, "fr": { "value": "Autre", 'text': "Autre" } },
    ];
    return (
        <div className="create-account Aide-page pt-5 pb-5 form-store-register" lang={Lang === 'ar' ? "ar" : 'fr'}>
            <div className="text-center mt-4 mb-5">
                <img alt="logodiardzair" src="/img/logo-fr.svg" width={186} height="59.911" />
            </div>
            <div className="ms-4 lang-section mb-4 text-center">
                <div className="sl-nav">
                    <ul>
                        <li>
                            <b className="lang-menu" style={{ color: 'black' }}>{Lang === "fr" ? 'Francais' : 'العربية'}</b>
                            {/* <b><img src={'/img/' + Lang + '.jpg'} className='lang-menu' alt='' /></b>  */}

                            <i className="fa fa-angle-down" style={{ color: 'black' }} aria-hidden="true" />
                            <div className="triangle" ></div>
                            <ul>
                                <div className='pad-lang'></div>
                                <li onClick={() => changeLang('fr')}><i className="sl-flag flag-fr" ><div id="French" /></i> <span className={Lang === "fr" ? "active lang-text" : 'lang-text'}> {Lang === "fr" ? 'Français' : 'الفرنسية'} </span></li>
                                <li onClick={() => changeLang('ar')}><i className="sl-flag flag-usa"><div id="English" /></i> <span className={Lang === "ar" ? "active lang-text" : 'lang-text'}> {Lang === "ar" ? 'العربية' : 'Arabe'}  </span></li>
                            </ul>
                        </li>
                    </ul>
                </div>
                <div className='pb-hadi'></div>
            </div>

            {Loading &&
                <Loader />
            }
            {/* <h6 className="text-center mb-5 mt-4">
    Veuillez remplir le formulaire pour vous inscrire au service (Store)
    </h6> */}
            <div className='container py-3'>
                {error?.length > 0 && error?.map((item, i) => (

                    item.constructor == String ?
                        <div className="alert-store" role="alert">
                            - {item}
                        </div>
                        : ''

                ))
                }

            </div>
            <div className={`container  mt-2 d-flex `} lang={Lang === 'ar' ? "ar" : 'fr'} >
                <div className='form-store'>
                    <form className="row g-5"
                        dir={Lang === 'ar' ? 'rtl' : 'ltr'}
                    >

                        <div className="col-lg-6">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" className={Lang === 'ar' ? "ms-2" : 'me-2'} viewBox="0 0 24 24">
                                <g id="Union_5" data-name="Union 5" fill="none" stroke-linejoin="round">
                                    <path d="M13.2,24V13.2H24V24ZM0,24V13.2H10.8V24ZM13.2,10.8V0H24V10.8ZM0,10.8V0H10.8V10.8Z" stroke="none" />
                                    <path d="M 22.10000038146973 22.10000038146973 L 22.10000038146973 15.09988975524902 L 15.09988975524902 15.09988975524902 L 15.09988975524902 22.10000038146973 L 22.10000038146973 22.10000038146973 M 8.900110244750977 22.10000038146973 L 8.900110244750977 15.09988975524902 L 1.899999976158142 15.09988975524902 L 1.899999976158142 22.10000038146973 L 8.900110244750977 22.10000038146973 M 22.10000038146973 8.900110244750977 L 22.10000038146973 1.899999976158142 L 15.09988975524902 1.899999976158142 L 15.09988975524902 8.900110244750977 L 22.10000038146973 8.900110244750977 M 8.900110244750977 8.900110244750977 L 8.900110244750977 1.899999976158142 L 1.899999976158142 1.899999976158142 L 1.899999976158142 8.900110244750977 L 8.900110244750977 8.900110244750977 M 24 24 L 13.19989013671875 24 L 13.19989013671875 13.19989013671875 L 24 13.19989013671875 L 24 24 Z M 10.80010986328125 24 L -1.77635683940025e-15 24 L -1.77635683940025e-15 13.19989013671875 L 10.80010986328125 13.19989013671875 L 10.80010986328125 24 Z M 24 10.80010986328125 L 13.19989013671875 10.80010986328125 L 13.19989013671875 -1.77635683940025e-15 L 24 -1.77635683940025e-15 L 24 10.80010986328125 Z M 10.80010986328125 10.80010986328125 L -1.77635683940025e-15 10.80010986328125 L -1.77635683940025e-15 -1.77635683940025e-15 L 10.80010986328125 -1.77635683940025e-15 L 10.80010986328125 10.80010986328125 Z" stroke="none" fill="#6d6d6d" />
                                </g>
                            </svg>
                            <label htmlFor="inputEmail4" className="form-label">{Label?.name[Lang]}</label>
                            <input maxLength={300} type="text" onChange={(e) => setNometPrenom(e.target.value)} value={NometPrenom} className="form-control" id="inputEmail4" />
                            <div className='err-cart-sum'>{Showerrors && errors.NometPrenom[Lang] !== '' ? errors.NometPrenom[Lang] : ''}</div>
                        </div>



                        <div className="col-lg-6">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" className={Lang === 'ar' ? "ms-2" : 'me-2'} viewBox="0 0 24 24">
                                <g id="Union_5" data-name="Union 5" fill="none" stroke-linejoin="round">
                                    <path d="M13.2,24V13.2H24V24ZM0,24V13.2H10.8V24ZM13.2,10.8V0H24V10.8ZM0,10.8V0H10.8V10.8Z" stroke="none" />
                                    <path d="M 22.10000038146973 22.10000038146973 L 22.10000038146973 15.09988975524902 L 15.09988975524902 15.09988975524902 L 15.09988975524902 22.10000038146973 L 22.10000038146973 22.10000038146973 M 8.900110244750977 22.10000038146973 L 8.900110244750977 15.09988975524902 L 1.899999976158142 15.09988975524902 L 1.899999976158142 22.10000038146973 L 8.900110244750977 22.10000038146973 M 22.10000038146973 8.900110244750977 L 22.10000038146973 1.899999976158142 L 15.09988975524902 1.899999976158142 L 15.09988975524902 8.900110244750977 L 22.10000038146973 8.900110244750977 M 8.900110244750977 8.900110244750977 L 8.900110244750977 1.899999976158142 L 1.899999976158142 1.899999976158142 L 1.899999976158142 8.900110244750977 L 8.900110244750977 8.900110244750977 M 24 24 L 13.19989013671875 24 L 13.19989013671875 13.19989013671875 L 24 13.19989013671875 L 24 24 Z M 10.80010986328125 24 L -1.77635683940025e-15 24 L -1.77635683940025e-15 13.19989013671875 L 10.80010986328125 13.19989013671875 L 10.80010986328125 24 Z M 24 10.80010986328125 L 13.19989013671875 10.80010986328125 L 13.19989013671875 -1.77635683940025e-15 L 24 -1.77635683940025e-15 L 24 10.80010986328125 Z M 10.80010986328125 10.80010986328125 L -1.77635683940025e-15 10.80010986328125 L -1.77635683940025e-15 -1.77635683940025e-15 L 10.80010986328125 -1.77635683940025e-15 L 10.80010986328125 10.80010986328125 Z" stroke="none" fill="#6d6d6d" />
                                </g>
                            </svg>
                            <label htmlFor="inputAddress2" className="form-label">{Label?.Mobile[Lang]}</label>
                            <input type="tel" maxLength={12} onChange={(e) => setTel(e.target.value.replace(/[^0-9]+/g, ''))} value={Tel} className="form-control" id="inputAddress2" placeholder="" />
                            <div className='err-cart-sum'>{Showerrors && errors.Tel[Lang] !== '' ? errors.Tel[Lang] : ''}</div>
                        </div>
                        <div className="col-lg-6">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" className={Lang === 'ar' ? "ms-2" : 'me-2'} viewBox="0 0 24 24">
                                <g id="Union_5" data-name="Union 5" fill="none" stroke-linejoin="round">
                                    <path d="M13.2,24V13.2H24V24ZM0,24V13.2H10.8V24ZM13.2,10.8V0H24V10.8ZM0,10.8V0H10.8V10.8Z" stroke="none" />
                                    <path d="M 22.10000038146973 22.10000038146973 L 22.10000038146973 15.09988975524902 L 15.09988975524902 15.09988975524902 L 15.09988975524902 22.10000038146973 L 22.10000038146973 22.10000038146973 M 8.900110244750977 22.10000038146973 L 8.900110244750977 15.09988975524902 L 1.899999976158142 15.09988975524902 L 1.899999976158142 22.10000038146973 L 8.900110244750977 22.10000038146973 M 22.10000038146973 8.900110244750977 L 22.10000038146973 1.899999976158142 L 15.09988975524902 1.899999976158142 L 15.09988975524902 8.900110244750977 L 22.10000038146973 8.900110244750977 M 8.900110244750977 8.900110244750977 L 8.900110244750977 1.899999976158142 L 1.899999976158142 1.899999976158142 L 1.899999976158142 8.900110244750977 L 8.900110244750977 8.900110244750977 M 24 24 L 13.19989013671875 24 L 13.19989013671875 13.19989013671875 L 24 13.19989013671875 L 24 24 Z M 10.80010986328125 24 L -1.77635683940025e-15 24 L -1.77635683940025e-15 13.19989013671875 L 10.80010986328125 13.19989013671875 L 10.80010986328125 24 Z M 24 10.80010986328125 L 13.19989013671875 10.80010986328125 L 13.19989013671875 -1.77635683940025e-15 L 24 -1.77635683940025e-15 L 24 10.80010986328125 Z M 10.80010986328125 10.80010986328125 L -1.77635683940025e-15 10.80010986328125 L -1.77635683940025e-15 -1.77635683940025e-15 L 10.80010986328125 -1.77635683940025e-15 L 10.80010986328125 10.80010986328125 Z" stroke="none" fill="#6d6d6d" />
                                </g>
                            </svg>
                            <label htmlFor="inputEmail4" className="form-label">{Label?.wilaya[Lang]}</label>
                            <select class="form-select" aria-label="Default select example" onChange={(e) => setWilaya(e.target.value)}>
                                <option disabled selected={Wilaya == "" ? "selected" : ''} value={''} >{Label?.wilaya[Lang]}</option>
                                <label htmlFor="inputState" className="form-label">{Label?.wilaya[Lang]}</label>
                                {WilayaList.length > 0 && WilayaList.map((item, i) => (

                                    <option value={item.value}>{item.text}</option>

                                ))
                                }

                            </select>
                            <div className='err-cart-sum'>{Showerrors && errors.Wilaya[Lang] !== '' ? errors.Wilaya[Lang] : ''}</div>

                        </div>
                        <div className="col-lg-6">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" className={Lang === 'ar' ? "ms-2" : 'me-2'} viewBox="0 0 24 24">
                                <g id="Union_5" data-name="Union 5" fill="none" stroke-linejoin="round">
                                    <path d="M13.2,24V13.2H24V24ZM0,24V13.2H10.8V24ZM13.2,10.8V0H24V10.8ZM0,10.8V0H10.8V10.8Z" stroke="none" />
                                    <path d="M 22.10000038146973 22.10000038146973 L 22.10000038146973 15.09988975524902 L 15.09988975524902 15.09988975524902 L 15.09988975524902 22.10000038146973 L 22.10000038146973 22.10000038146973 M 8.900110244750977 22.10000038146973 L 8.900110244750977 15.09988975524902 L 1.899999976158142 15.09988975524902 L 1.899999976158142 22.10000038146973 L 8.900110244750977 22.10000038146973 M 22.10000038146973 8.900110244750977 L 22.10000038146973 1.899999976158142 L 15.09988975524902 1.899999976158142 L 15.09988975524902 8.900110244750977 L 22.10000038146973 8.900110244750977 M 8.900110244750977 8.900110244750977 L 8.900110244750977 1.899999976158142 L 1.899999976158142 1.899999976158142 L 1.899999976158142 8.900110244750977 L 8.900110244750977 8.900110244750977 M 24 24 L 13.19989013671875 24 L 13.19989013671875 13.19989013671875 L 24 13.19989013671875 L 24 24 Z M 10.80010986328125 24 L -1.77635683940025e-15 24 L -1.77635683940025e-15 13.19989013671875 L 10.80010986328125 13.19989013671875 L 10.80010986328125 24 Z M 24 10.80010986328125 L 13.19989013671875 10.80010986328125 L 13.19989013671875 -1.77635683940025e-15 L 24 -1.77635683940025e-15 L 24 10.80010986328125 Z M 10.80010986328125 10.80010986328125 L -1.77635683940025e-15 10.80010986328125 L -1.77635683940025e-15 -1.77635683940025e-15 L 10.80010986328125 -1.77635683940025e-15 L 10.80010986328125 10.80010986328125 Z" stroke="none" fill="#6d6d6d" />
                                </g>
                            </svg>
                            <label htmlFor="inputEmail4" className="form-label">{Label?.commune[Lang]}</label>
                            <select class="form-select" aria-label="Default select example" onChange={(e) => setCommune(e.target.value)}>
                                {/* {CommuneList.length === 0 || CommuneList.length > 0 && */}
                                <option disabled selected={Commune == "" ? "selected" : ''} value={''}>{Communesdenaissence.length > 0 ? Lang === "fr" ? "Commune" : "البلدية" : Lang === "fr" ? "Veuillez sélectionner La Wilaya" : "يرجى تحديد الولاية لإختيار البلدية"}</option>
                                {/* } */}


                                {Communesdenaissence.length > 0 && Communesdenaissence.map((item, i) => (
                                    <option selected={Commune === item?.commune} value={item?.commune}>{item?.commune}</option>
                                ))
                                }
                            </select>
                            <div className='err-cart-sum'>{Showerrors && errors.Commune[Lang] !== '' ? errors.Commune[Lang] : ''}</div>

                        </div>

                        <div className="col-lg-6">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" className={Lang === 'ar' ? "ms-2" : 'me-2'} viewBox="0 0 24 24">
                                <g id="Union_5" data-name="Union 5" fill="none" stroke-linejoin="round">
                                    <path d="M13.2,24V13.2H24V24ZM0,24V13.2H10.8V24ZM13.2,10.8V0H24V10.8ZM0,10.8V0H10.8V10.8Z" stroke="none" />
                                    <path d="M 22.10000038146973 22.10000038146973 L 22.10000038146973 15.09988975524902 L 15.09988975524902 15.09988975524902 L 15.09988975524902 22.10000038146973 L 22.10000038146973 22.10000038146973 M 8.900110244750977 22.10000038146973 L 8.900110244750977 15.09988975524902 L 1.899999976158142 15.09988975524902 L 1.899999976158142 22.10000038146973 L 8.900110244750977 22.10000038146973 M 22.10000038146973 8.900110244750977 L 22.10000038146973 1.899999976158142 L 15.09988975524902 1.899999976158142 L 15.09988975524902 8.900110244750977 L 22.10000038146973 8.900110244750977 M 8.900110244750977 8.900110244750977 L 8.900110244750977 1.899999976158142 L 1.899999976158142 1.899999976158142 L 1.899999976158142 8.900110244750977 L 8.900110244750977 8.900110244750977 M 24 24 L 13.19989013671875 24 L 13.19989013671875 13.19989013671875 L 24 13.19989013671875 L 24 24 Z M 10.80010986328125 24 L -1.77635683940025e-15 24 L -1.77635683940025e-15 13.19989013671875 L 10.80010986328125 13.19989013671875 L 10.80010986328125 24 Z M 24 10.80010986328125 L 13.19989013671875 10.80010986328125 L 13.19989013671875 -1.77635683940025e-15 L 24 -1.77635683940025e-15 L 24 10.80010986328125 Z M 10.80010986328125 10.80010986328125 L -1.77635683940025e-15 10.80010986328125 L -1.77635683940025e-15 -1.77635683940025e-15 L 10.80010986328125 -1.77635683940025e-15 L 10.80010986328125 10.80010986328125 Z" stroke="none" fill="#6d6d6d" />
                                </g>
                            </svg>
                            <label htmlFor="inputEmail4" className="form-label">{Label?.secteur[Lang]}</label>
                            <select class="form-select" aria-label="Default select example" onChange={(e) => setsecteuActivité(e.target.value)}>
                                <option disabled selected={secteuActivité == "" ? "selected" : ''} value={''} >{Label?.secteur[Lang]}</option>
                                <label htmlFor="inputState" className="form-label">{Label?.secteur[Lang]}</label>
                                {secteuActivitéList.length > 0 && secteuActivitéList.map((item, i) => (

                                    <option value={item[Lang].value}>{item[Lang].text}</option>

                                ))
                                }

                            </select>
                            <div className='err-cart-sum'>{Showerrors && errors.secteuActivité[Lang] !== '' ? errors.secteuActivité[Lang] : ''}</div>

                        </div>

                        {/* <div className="col-lg-12">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" className={Lang === 'ar' ? "ms-2" : 'me-2'} viewBox="0 0 24 24">
                                <g id="Union_5" data-name="Union 5" fill="none" stroke-linejoin="round">
                                    <path d="M13.2,24V13.2H24V24ZM0,24V13.2H10.8V24ZM13.2,10.8V0H24V10.8ZM0,10.8V0H10.8V10.8Z" stroke="none" />
                                    <path d="M 22.10000038146973 22.10000038146973 L 22.10000038146973 15.09988975524902 L 15.09988975524902 15.09988975524902 L 15.09988975524902 22.10000038146973 L 22.10000038146973 22.10000038146973 M 8.900110244750977 22.10000038146973 L 8.900110244750977 15.09988975524902 L 1.899999976158142 15.09988975524902 L 1.899999976158142 22.10000038146973 L 8.900110244750977 22.10000038146973 M 22.10000038146973 8.900110244750977 L 22.10000038146973 1.899999976158142 L 15.09988975524902 1.899999976158142 L 15.09988975524902 8.900110244750977 L 22.10000038146973 8.900110244750977 M 8.900110244750977 8.900110244750977 L 8.900110244750977 1.899999976158142 L 1.899999976158142 1.899999976158142 L 1.899999976158142 8.900110244750977 L 8.900110244750977 8.900110244750977 M 24 24 L 13.19989013671875 24 L 13.19989013671875 13.19989013671875 L 24 13.19989013671875 L 24 24 Z M 10.80010986328125 24 L -1.77635683940025e-15 24 L -1.77635683940025e-15 13.19989013671875 L 10.80010986328125 13.19989013671875 L 10.80010986328125 24 Z M 24 10.80010986328125 L 13.19989013671875 10.80010986328125 L 13.19989013671875 -1.77635683940025e-15 L 24 -1.77635683940025e-15 L 24 10.80010986328125 Z M 10.80010986328125 10.80010986328125 L -1.77635683940025e-15 10.80010986328125 L -1.77635683940025e-15 -1.77635683940025e-15 L 10.80010986328125 -1.77635683940025e-15 L 10.80010986328125 10.80010986328125 Z" stroke="none" fill="#6d6d6d" />
                                </g>
                            </svg>
                            <label htmlFor="inputAddress" className="form-label">{Label?.secteur[Lang]}</label>
                            <input maxLength={300} type="text" className="form-control" onChange={(e) => setsecteuActivité(e.target.value)} value={secteuActivité} id="inputAddress" placeholder="" />
                            <div className='err-cart-sum'>{Showerrors && errors.secteuActivité[Lang] !== '' ? errors.secteuActivité[Lang] : ''}</div>
                        </div> */}
                        <div className="col-12 mt-5">
                            <div onClick={() => GoNext()} className="store-form-register--btn">
                                {Lang === 'fr' ? "Inscription" : "إرسال الطلب"}
                            </div>
                        </div>
                    </form>

                </div>
            </div>

        </div>
    )
}



export default MakePdf